import { render, staticRenderFns } from "./FormAgency.vue?vue&type=template&id=5bedfe25"
import script from "./FormAgency.vue?vue&type=script&lang=js"
export * from "./FormAgency.vue?vue&type=script&lang=js"
import style0 from "./FormAgency.vue?vue&type=style&index=0&id=5bedfe25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports